import axios from "axios";
import ReusableTable from "../ReusableTable/ReusableTable";
import classes from "./LabsProfiles.module.css";
import { env } from "../../constants/env";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const LabsProfiles = () => {
  const navigate = useNavigate();
  const { token, user } = useAuth();
  const userRole = user?.role;
  const [labData, setLabData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLabs = async () => {
    try {
      const res = await axios.get(`${env.kataApiUrl}/api/labs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const formatted = res.data.map((lab) => ({
        dateTime: new Date(lab.createdAt).toLocaleString(),
        labName: lab.labName,
        license: lab.hpczLicense,
        address: lab.physicalAddress || "",
        phone: lab.telephone,
        email: lab.email,
        id: lab._id,
      }));
      setLabData(formatted);
    } catch (err) {
      console.error("Error fetching labs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLabs();
  }, []);

  // ✅ Delete lab function
  const handleDelete = async (lab) => {
    if (!window.confirm(`Are you sure you want to delete ${lab.labName}?`)) {
      return;
    }

    try {
      await axios.delete(`${env.kataApiUrl}/api/profile/${lab.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabData((prev) => prev.filter((l) => l.id !== lab.id));
      toast.success(`Successfully deleted ${lab.labName}`);
    } catch (err) {
      console.error("Error deleting lab:", err);
      toast.error("Failed to delete lab");
    }
  };

  return (
    <div className={classes.wrapper}>
      <ReusableTable
        title="Labs Profiles"
        columns={[
          { label: "Date & Time Entered", field: "dateTime" },
          { label: "Laboratory Name", field: "labName" },
          { label: "HPCZ License Number", field: "license" },
          { label: "Physical Address", field: "address" },
          { label: "Facility Phone", field: "phone" },
          { label: "Facility Email", field: "email" },
        ]}
        data={labData}
        onAdd={
          userRole === "OWNER" || userRole === "MINISTRY"
            ? () => navigate("/laboratory-mapping/profile/edit-profile")
            : undefined
        }
        showTopAdd={
          (userRole === "OWNER" && labData.length > 0) ||
          (userRole === "MINISTRY" && labData.length > 0)
        }
        onDelete={handleDelete} // ✅ Pass delete handler
      />
    </div>
  );
};

export default LabsProfiles;
